export default function highlightActive(
  navLinks: NodeListOf<HTMLAnchorElement>,
) {
  navLinks.forEach((link) => {
    const currentPath = window.location.pathname;
    const pathname = new URL(link.href).pathname;
    const isParentMatch = currentPath.startsWith(pathname);
    const isRootMatch = pathname === "/";
    const isExactPathMatch = currentPath === pathname;

    link.classList.remove("active");

    if (
      link.hasAttribute("data-navigation-match-parent") &&
      (isExactPathMatch || isParentMatch) &&
      !isRootMatch
    ) {
      link.classList.add("active");
    }

    if (isExactPathMatch && !isRootMatch) {
      link.classList.add("active");
    }
  });
}
